var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9075 0.3C13.451 -0.1 12.7663 -0.1 12.3098 0.3L0.897068 10.3C0.668814 10.5 0.554688 10.7 0.554688 11V15C0.554688 15.6 1.0112 16 1.69596 16H6.26104C6.60342 16 6.83167 15.9 7.05993 15.7L18.4726 5.7C18.9291 5.3 18.9291 4.7 18.4726 4.3L13.9075 0.3ZM5.80422 14H2.83691V11.4L9.68453 5.40002L12.6518 8.00002L5.80422 14ZM11.2832 4.00002L14.2505 6.60002L16.0765 5.00002L13.1092 2.40002L11.2832 4.00002Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilChange);
export default __webpack_public_path__ + "static/media/pencilChange.a3bd945f12e9c499442859c7244eb4eb.svg";
export { ForwardRef as ReactComponent };